import { createClient } from '@/lib/supabase/client'

/**
 * The access token to send to the API.
 *
 * This module used to be an indirection with a registration hook. One query
 * descriptor was shared by a Server Component (`prefetchQuery`) and the client
 * component that hydrated it (`useSuspenseQuery`), so a single `queryFn` had to
 * work in both places — but the two held the session in different places, and
 * the server's lived behind `next/headers`. A `typeof window` branch around a
 * dynamic import did not help: bundlers follow dynamic imports regardless of
 * reachability, so `next/headers` landed in the client graph and the build
 * failed with "You're importing a component that needs next/headers". The
 * server therefore REGISTERED its resolver at startup, and this module was
 * written so as never to name a server API.
 *
 * There is one runtime now, so there is one implementation.
 */
export async function getAccessToken(): Promise<string | null> {
  const {
    data: { session },
  } = await createClient().auth.getSession()

  return session?.access_token ?? null
}
